import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth API (cambio password self-service per master/slave/super-admin)
export const authApi = {
  changeMyPassword: (old_password, new_password) =>
    axios.put(`${API}/auth/password`, { old_password, new_password }),
};

// Clients API
export const clientsApi = {
  getAll: (search = '') => axios.get(`${API}/clients`, { params: { search } }),
  getById: (id) => axios.get(`${API}/clients/${id}`),
  create: (data, confirm_duplicate = false) => axios.post(`${API}/clients`, data, { params: { confirm_duplicate } }),
  update: (id, data, confirm_duplicate = false) => axios.put(`${API}/clients/${id}`, data, { params: { confirm_duplicate } }),
  delete: (id) => axios.delete(`${API}/clients/${id}`),
  productPrices: (id) => axios.get(`${API}/clients/${id}/product-prices`),
  deleteProductPrice: (id, productId) => axios.delete(`${API}/clients/${id}/product-prices/${productId}`),
  lastDdtSummary: (id, exclude_ddt_id) => axios.get(`${API}/clients/${id}/last-ddt-summary`, { params: exclude_ddt_id ? { exclude_ddt_id } : {} }),
};

// Products API
export const productsApi = {
  getAll: (search = '') => axios.get(`${API}/products`, { params: { search } }),
  getById: (id) => axios.get(`${API}/products/${id}`),
  create: (data) => axios.post(`${API}/products`, data),
  update: (id, data) => axios.put(`${API}/products/${id}`, data),
  delete: (id) => axios.delete(`${API}/products/${id}`),
  exportCsv: () => axios.get(`${API}/products/export/csv`, { responseType: 'blob' }),
  importCsv: (csv_text, replace_existing = false) => axios.post(`${API}/products/import/csv`, { csv_text, replace_existing }),
};

// DDT API
export const ddtApi = {
  getAll: (params = {}) => axios.get(`${API}/ddt`, { params }),
  getById: (id) => axios.get(`${API}/ddt/${id}`),
  create: (data, draft_id = null) => axios.post(`${API}/ddt`, data, { params: draft_id ? { draft_id } : {} }),
  update: (id, data) => axios.put(`${API}/ddt/${id}`, data),
  delete: (id, confirm) => axios.delete(`${API}/ddt/${id}`, { params: { confirm } }),
  bulkDelete: (ids, confirm) => axios.post(`${API}/ddt/bulk-delete`, { ids, confirm }),
  getPdf: (id) => axios.get(`${API}/ddt/${id}/pdf`, { responseType: 'blob' }),
  // Cestino
  trashList: () => axios.get(`${API}/ddt/trash/list`),
  restore: (id) => axios.post(`${API}/ddt/${id}/restore`),
  purge: (id, confirm) => axios.delete(`${API}/ddt/${id}/purge`, { params: { confirm } }),
  // Export ZIP per periodo
  exportZip: (year, month = null) =>
    axios.get(`${API}/ddt/export/zip`, { params: month ? { year, month } : { year }, responseType: 'blob' }),
};

// Fatture elettroniche
export const invoicesApi = {
  getAll: (params = {}) => axios.get(`${API}/invoices`, { params }),
  getById: (id) => axios.get(`${API}/invoices/${id}`),
  create: (data) => axios.post(`${API}/invoices`, data),
  fromDdt: (ddt_ids, date) => axios.post(`${API}/invoices/from-ddt`, { ddt_ids, date }),
  availableDdt: (client_id) => axios.get(`${API}/invoices/available-ddt`, { params: { client_id } }),
  update: (id, data) => axios.put(`${API}/invoices/${id}`, data),
  delete: (id) => axios.delete(`${API}/invoices/${id}`),
  check: (id) => axios.post(`${API}/invoices/${id}/check`),
  send: (id) => axios.post(`${API}/invoices/${id}/send`),
  refreshStatus: (id) => axios.post(`${API}/invoices/${id}/refresh-status`),
  getXml: (id) => axios.get(`${API}/invoices/${id}/xml`, { responseType: 'blob' }),
  getPdf: (id) => axios.get(`${API}/invoices/${id}/pdf`, { responseType: 'blob' }),
};

export const einvoiceApi = {
  getAccess: () => axios.get(`${API}/einvoice/access`),
  startTrial: () => axios.post(`${API}/einvoice/start-trial`),
  getSettings: () => axios.get(`${API}/einvoice/settings`),
  updateSettings: (data) => axios.put(`${API}/einvoice/settings`, data),
  testConnection: () => axios.post(`${API}/einvoice/test-connection`),
};

export const noticesApi = {
  get: (key) => axios.get(`${API}/notices/${key}`),
  accept: (key) => axios.post(`${API}/notices/${key}/accept`),
};

// Quotes (Preventivi) API
export const quotesApi = {
  getAll: (params = {}) => axios.get(`${API}/quotes`, { params }),
  getById: (id) => axios.get(`${API}/quotes/${id}`),
  create: (data) => axios.post(`${API}/quotes`, data),
  update: (id, data) => axios.put(`${API}/quotes/${id}`, data),
  delete: (id) => axios.delete(`${API}/quotes/${id}`),
  convertToDdt: (id) => axios.post(`${API}/quotes/${id}/convert-to-ddt`),
  getPdf: (id) => axios.get(`${API}/quotes/${id}/pdf`, { responseType: 'blob' }),
};

// Suppliers (Fornitori) API
export const suppliersApi = {
  getAll: (search = '') => axios.get(`${API}/suppliers`, { params: { search } }),
  getById: (id) => axios.get(`${API}/suppliers/${id}`),
  create: (data) => axios.post(`${API}/suppliers`, data),
  update: (id, data) => axios.put(`${API}/suppliers/${id}`, data),
  delete: (id) => axios.delete(`${API}/suppliers/${id}`),
};

// Purchases (DDT Acquisto / Carico Magazzino) API
export const purchasesApi = {
  getAll: (params = {}) => axios.get(`${API}/purchases`, { params }),
  getById: (id) => axios.get(`${API}/purchases/${id}`),
  create: (data) => axios.post(`${API}/purchases`, data),
  update: (id, data) => axios.put(`${API}/purchases/${id}`, data),
  delete: (id) => axios.delete(`${API}/purchases/${id}`),
};

// DDT Drafts API — autosave server-side
export const ddtDraftsApi = {
  getCurrent: () => axios.get(`${API}/ddt-drafts/current`),
  save: (data, draft_id = null) => axios.post(`${API}/ddt-drafts`, data, { params: draft_id ? { draft_id } : {} }),
  delete: (id) => axios.delete(`${API}/ddt-drafts/${id}`),
};

// Expenses API (Uscite)
export const expensesApi = {
  list: (year, month) => axios.get(`${API}/expenses`, { params: { year, month } }),
  create: (data) => axios.post(`${API}/expenses`, data),
  update: (id, data) => axios.put(`${API}/expenses/${id}`, data),
  delete: (id) => axios.delete(`${API}/expenses/${id}`),
};

// Incomes API (Entrate)
export const incomesApi = {
  list: (year, month) => axios.get(`${API}/incomes`, { params: { year, month } }),
  create: (data) => axios.post(`${API}/incomes`, data),
  update: (id, data) => axios.put(`${API}/incomes/${id}`, data),
  delete: (id) => axios.delete(`${API}/incomes/${id}`),
};

// Inbox DDT API (invio/ricezione fra aziende)
export const inboxApi = {
  directory: () => axios.get(`${API}/companies/directory`),
  lookupByPiva: (piva) => axios.get(`${API}/companies/lookup-by-piva`, { params: { piva } }),
  send: (ddtId, toCompanyId) => axios.post(`${API}/ddt/${ddtId}/send-to-company`, { to_company_id: toCompanyId }),
  list: (status) => axios.get(`${API}/inbox`, { params: status ? { status } : {} }),
  accept: (inboxId) => axios.post(`${API}/inbox/${inboxId}/accept`),
  reject: (inboxId) => axios.post(`${API}/inbox/${inboxId}/reject`),
  // PDF del DDT ricevuto: scarica un blob e lo apre in nuovo tab (visualizza + stampa + download).
  pdfBlob: (inboxId) => axios.get(`${API}/inbox/${inboxId}/pdf`, { responseType: 'blob' }),
};

// Payments API
export const paymentsApi = {
  getAll: (params = {}) => axios.get(`${API}/payments`, { params }),
  create: (data) => axios.post(`${API}/payments`, data),
  delete: (id) => axios.delete(`${API}/payments/${id}`),
};

// Statement (estratto conto)
export const statementApi = {
  get: (clientId, params = {}) => axios.get(`${API}/statement/${clientId}`, { params }),
  getGlobal: (params = {}) => axios.get(`${API}/statement-all`, { params }),
};

// Company Settings API (for company users)
export const companyApi = {
  get: () => axios.get(`${API}/company/settings`),
  update: (data) => axios.put(`${API}/company/settings`, data),
};

// Dashboard API
export const dashboardApi = {
  getStats: () => axios.get(`${API}/dashboard/stats`),
  getMonthlyStats: (months = 12) => axios.get(`${API}/dashboard/monthly-stats`, { params: { months } }),
};

// Admin API (super admin only)
export const adminApi = {
  getStats: () => axios.get(`${API}/admin/stats`),
  getCompanies: () => axios.get(`${API}/admin/companies`),
  getCompany: (id) => axios.get(`${API}/admin/companies/${id}`),
  createCompany: (data) => axios.post(`${API}/admin/companies`, data),
  updateCompany: (id, data) => axios.put(`${API}/admin/companies/${id}`, data),
  deleteCompany: (id, hard = false) => axios.delete(`${API}/admin/companies/${id}`, { params: { hard } }),
  toggleCompanyActive: (id) => axios.put(`${API}/admin/companies/${id}/toggle-active`),
  changeCompanyPassword: (id, new_password) => axios.put(`${API}/admin/companies/${id}/password`, { new_password }),
  resetCompanyPasswordRandom: (id, target = 'master') => axios.post(`${API}/admin/companies/${id}/reset-password-random`, null, { params: { target } }),
  changeCompanyUsername: (id, new_username) => axios.put(`${API}/admin/companies/${id}/username`, { new_username }),
  setSlaveCredentials: (id, slave_username, slave_password) => axios.put(`${API}/admin/companies/${id}/slave-credentials`, { slave_username, slave_password }),
  renewSubscription: (id, days = 365, extend_from_today = false) =>
    axios.put(`${API}/admin/companies/${id}/renew-subscription`, { days, extend_from_today }),
  setEinvoiceAccess: (id, enabled) => axios.put(`${API}/admin/companies/${id}/einvoice-access`, { enabled }),
  changeMyPassword: (new_password) => axios.put(`${API}/admin/me/password`, { new_password }),
  getHistory: (params = {}) => axios.get(`${API}/admin/history`, { params }),
  // legacy - kept for compatibility
  getUsers: (companyId = null) => axios.get(`${API}/admin/users`, { params: { company_id: companyId } }),
  createUser: (data) => axios.post(`${API}/admin/users`, data),
  toggleUserActive: (id) => axios.put(`${API}/admin/users/${id}/toggle-active`),
  resetPassword: (id, newPassword) => axios.put(`${API}/admin/users/${id}/reset-password`, { new_password: newPassword }),
};
